"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORM_SABLON_ICE_AKTARMA_ORNEK_SATIRLARI = exports.FORM_SABLON_ICE_AKTARMA_MESAJLARI = exports.FormSablonIceAktarmaHatasi = exports.EXCEL_KANIT_AYARI_ETIKETI = exports.EXCEL_ALAN_TIPI_ETIKETI = exports.EXCEL_ALAN_TIPLERI = exports.FORM_SABLON_ICE_AKTARMA_SAYFA_ADI = exports.FORM_SABLON_ICE_AKTARMA_DOSYA_ADI = exports.FORM_SABLON_ICE_AKTARMA_SUTUNLARI = void 0;
exports.excelKodGovdesi = excelKodGovdesi;
exports.formSablonunuSatirlardanKur = formSablonunuSatirlardanKur;
exports.formSablonIceAktarmaNotlari = formSablonIceAktarmaNotlari;
const form_schema_1 = require("./form-schema");
/**
 * FORM ŞABLONU — EXCEL İÇE AKTARMA, SAF YARISI (Namet grubu / P1 — 01.11.2026;
 * Kapsam §14 · §22.5).
 *
 * Ürün kararı: müşteri kendi formunu **bizim sabit Excel şablonumuza** döker,
 * yükler; sistem **yeni şablon, taslak v1** açar; kullanıcı mevcut düzenleyicide
 * düzeltir. **Önizleme ekranı YOK**; serbest Excel okuyucu KAPSAM DIŞI.
 *
 * ⚠️ **MOTOR SINIRI AYNEN (§22.5/2):** bu dosya satırları ALANA çevirir —
 * hesap, koşul, skor yazmaz. İçe aktarma motoru (`import-engine`) hücreleri
 * metin olarak verir ve kural bilmez (cikti-ice-aktarma.md §2); satırın anlamı
 * BURADA, tek yerde çözülür — API ve web ikinci bir sözlük yazmaz.
 *
 * ⚠️ **TANINMAYAN DEĞER SATIRI DÜŞÜRMEZ:** satır yine madde olur, ilgili özellik
 * boş (ya da varsayılan) kalır ve `uyarilar`a *satır · alan · değer* yazılır —
 * kullanıcı düzenleyicide tamamlar. Düşen tek şey DOSYA düzeyidir: başlık
 * satırı tanımla uyuşmuyor (motor, `baslikDogrulanir`) · hiç veri satırı yok ·
 * Madde sütunu tamamen boş → 422 (D2 dili: gözlem · beklenti · çare).
 *
 * ⚠️ **TİP BOŞ OLAMAZ — varsayılanı `kontrol`dür** (düzenleyicinin yeni madde
 * varsayılanıyla aynı; checklist bu motorun en sık kurulan alanıdır). Tanınmayan
 * tip de `kontrol`e düşer ve UYARI üretir. *"Alan boş"* cümlesi tip için
 * *"varsayılana düşer"* diye okunur — şemada tipsiz alan yoktur.
 */
exports.FORM_SABLON_ICE_AKTARMA_SUTUNLARI = [
    'Bölüm',
    'Madde',
    'Tip',
    'Cevap seti',
    'Fotoğraf',
    'Not',
    'Zorunlu',
];
exports.FORM_SABLON_ICE_AKTARMA_DOSYA_ADI = 'form-sablonu-excel';
exports.FORM_SABLON_ICE_AKTARMA_SAYFA_ADI = 'Form';
/**
 * Excel'den açılabilen alan tipleri — düzenleyicinin MÜŞTERİ alan tipleri
 * (`MUSTERI_ALAN_TIPLERI`): seçim tipleri yok (XOR kaynağı Excel'den gelemez).
 * Etiketler düzenleyicinin TR etiketleriyle aynıdır (kullanıcı ekranda
 * gördüğünü yazar).
 */
exports.EXCEL_ALAN_TIPLERI = [
    'kontrol',
    'metin',
    'uzun_metin',
    'sayi',
    'tarih',
    'evet_hayir',
    'dosya',
];
exports.EXCEL_ALAN_TIPI_ETIKETI = {
    kontrol: 'Kontrol maddesi',
    metin: 'Kısa metin',
    uzun_metin: 'Uzun metin',
    sayi: 'Sayı',
    tarih: 'Tarih',
    evet_hayir: 'Evet / Hayır',
    dosya: 'Dosya',
};
exports.EXCEL_KANIT_AYARI_ETIKETI = {
    kapali: 'Kapalı',
    istege_bagli: 'İsteğe bağlı',
    zorunlu: 'Zorunlu',
};
/** Excel'de tanınan ek yazımlar (etiket + token + yaygın kısaltma). Anahtar normalize edilmiş metindir. */
const TIP_ESADLARI = {
    kontrol: 'kontrol',
    'kontrol maddesi': 'kontrol',
    madde: 'kontrol',
    checklist: 'kontrol',
    metin: 'metin',
    'kısa metin': 'metin',
    'kisa metin': 'metin',
    'uzun metin': 'uzun_metin',
    uzun_metin: 'uzun_metin',
    açıklama: 'uzun_metin',
    aciklama: 'uzun_metin',
    sayı: 'sayi',
    sayi: 'sayi',
    tarih: 'tarih',
    'evet / hayır': 'evet_hayir',
    'evet/hayır': 'evet_hayir',
    'evet hayır': 'evet_hayir',
    'evet/hayir': 'evet_hayir',
    'evet hayir': 'evet_hayir',
    evet_hayir: 'evet_hayir',
    dosya: 'dosya',
};
const KANIT_ESADLARI = {
    kapalı: 'kapali',
    kapali: 'kapali',
    yok: 'kapali',
    hayır: 'kapali',
    hayir: 'kapali',
    'isteğe bağlı': 'istege_bagli',
    'istege bagli': 'istege_bagli',
    istege_bagli: 'istege_bagli',
    'isteğe bağlı ': 'istege_bagli',
    isteğe: 'istege_bagli',
    opsiyonel: 'istege_bagli',
    evet: 'istege_bagli',
    var: 'istege_bagli',
    zorunlu: 'zorunlu',
};
const ZORUNLU_ESADLARI = {
    evet: true,
    e: true,
    x: true,
    '✓': true,
    '√': true,
    '1': true,
    true: true,
    zorunlu: true,
    hayır: false,
    hayir: false,
    h: false,
    '0': false,
    false: false,
    'isteğe bağlı': false,
    'istege bagli': false,
    opsiyonel: false,
};
/** Dosya düzeyinde ret — çağıran 422 çevirir; mesaj D2 dilinde (gözlem · beklenti · çare). */
class FormSablonIceAktarmaHatasi extends Error {
}
exports.FormSablonIceAktarmaHatasi = FormSablonIceAktarmaHatasi;
exports.FORM_SABLON_ICE_AKTARMA_MESAJLARI = {
    veriYok: 'Dosyada veri satırı yok. Beklenen: başlık satırının altında en az bir madde. Şablonu doldurup tekrar deneyin.',
    maddeYok: 'Madde sütunu boş: hiçbir satırda madde metni yok. Beklenen: her satırda bir madde. Maddeleri yazıp tekrar deneyin.',
};
/** Türkçe büyük/küçük harf ve boşluk farkını siler — eşadlar bununla aranır. */
function normalize(metin) {
    return metin.trim().replace(/\s+/g, ' ').toLocaleLowerCase('tr');
}
/**
 * Başlıktan ASCII kod gövdesi — düzenleyicinin `musteri_<slug>` kuralının
 * aynısı (alan kodu kullanıcıya sorulmaz; `form_answer.alan_kodu` eksenidir).
 */
function excelKodGovdesi(metin, azamiUzunluk = 40) {
    const govde = metin
        .replace(/İ/g, 'i')
        .replace(/I/g, 'i')
        .toLowerCase()
        .replace(/ç/g, 'c')
        .replace(/ğ/g, 'g')
        .replace(/ı/g, 'i')
        .replace(/ö/g, 'o')
        .replace(/ş/g, 's')
        .replace(/ü/g, 'u')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .slice(0, azamiUzunluk)
        .replace(/_+$/g, '');
    return govde || 'madde';
}
function benzersizKod(aday, kullanilan) {
    let kod = aday;
    for (let n = 2; kullanilan.has(kod); n += 1)
        kod = `${aday}_${n}`;
    kullanilan.add(kod);
    return kod;
}
/**
 * Ham satırlar → taslak şema. Kolon sırası `FORM_SABLON_ICE_AKTARMA_SUTUNLARI`
 * (şablonu üreten tanım da bunu okur — tek kaynak).
 *
 * Bölüm kuralı: dolu Bölüm hücresi **yeni bölüm başlatır** (aynı ad tekrar
 * gelirse o bölüme DEVAM eder), boşsa önceki bölüm sürer; ilk madde bölümsüzse
 * **"Genel"** bölümü açılır (`ORTUK_BOLUM_KODU`). Yalnız Bölüm yazan satır
 * (madde boş) bölüm başlığıdır, madde üretmez.
 */
function formSablonunuSatirlardanKur(satirlar) {
    if (satirlar.length === 0) {
        throw new FormSablonIceAktarmaHatasi(exports.FORM_SABLON_ICE_AKTARMA_MESAJLARI.veriYok);
    }
    const bolumler = [];
    const bolumAnahtari = new Map(); // normalize(başlık) → kod
    const bolumKodlari = new Set();
    const alanKodlari = new Set();
    const alanlar = [];
    const uyarilar = [];
    let aktifBolum = null;
    const bolumAc = (baslik) => {
        const anahtar = normalize(baslik);
        const mevcut = bolumAnahtari.get(anahtar);
        if (mevcut)
            return mevcut;
        // Bölüm kodu şemanın kimlik kuralına uyar (küçük harfle başlar, ≥ 2 karakter):
        // "A" ya da "1. Bölüm" gibi başlıklar öneki alır.
        const govde = excelKodGovdesi(baslik);
        const kod = benzersizKod(/^[a-z][a-z0-9_]+$/.test(govde) ? govde : `bolum_${govde}`, bolumKodlari);
        bolumler.push({ kod, baslik: baslik.trim(), sira: bolumler.length * 10 + 10 });
        bolumAnahtari.set(anahtar, kod);
        return kod;
    };
    for (const ham of satirlar) {
        const [bolum = '', madde = '', tip = '', set = '', foto = '', not = '', zorunlu = ''] = ham.hucreler;
        if (bolum.trim() !== '')
            aktifBolum = bolumAc(bolum);
        if (madde.trim() === '')
            continue;
        if (aktifBolum === null) {
            // İlk madde bölümsüz → "Genel" (hata değil). Kod örtük bölüm kodudur;
            // sonradan "Genel" adlı açık bir bölüm gelirse aynı bölüme düşer.
            bolumKodlari.add(form_schema_1.ORTUK_BOLUM_KODU);
            bolumler.push({ kod: form_schema_1.ORTUK_BOLUM_KODU, baslik: 'Genel', sira: bolumler.length * 10 + 10 });
            bolumAnahtari.set(normalize('Genel'), form_schema_1.ORTUK_BOLUM_KODU);
            aktifBolum = form_schema_1.ORTUK_BOLUM_KODU;
        }
        const uyar = (alan, deger) => {
            uyarilar.push({ satir: ham.satir, alan, deger: deger.trim() });
        };
        let alanTipi = 'kontrol';
        if (tip.trim() !== '') {
            const cozulen = TIP_ESADLARI[normalize(tip)];
            if (cozulen)
                alanTipi = cozulen;
            else
                uyar('Tip', tip);
        }
        let cevapSetiKodu = null;
        if (set.trim() !== '') {
            if (alanTipi !== 'kontrol') {
                uyar('Cevap seti', set);
            }
            else {
                const anahtar = normalize(set);
                const bulunan = form_schema_1.CEVAP_SETI_KUTUPHANESI.find((s) => normalize(s.kod) === anahtar || normalize(s.ad) === anahtar);
                if (bulunan)
                    cevapSetiKodu = bulunan.kod;
                else
                    uyar('Cevap seti', set);
            }
        }
        const kanit = (deger, alan) => {
            if (deger.trim() === '')
                return null;
            // `dosya` alanı zaten ek taşır — kanıt ayarı almaz (şema 422'si).
            if (alanTipi === 'dosya') {
                uyar(alan, deger);
                return null;
            }
            const cozulen = KANIT_ESADLARI[normalize(deger)];
            if (cozulen && form_schema_1.MADDE_KANIT_AYARLARI.includes(cozulen))
                return cozulen;
            uyar(alan, deger);
            return null;
        };
        const fotografAyari = kanit(foto, 'Fotoğraf');
        const notAyari = kanit(not, 'Not');
        let zorunluMu = true;
        if (zorunlu.trim() !== '') {
            const cozulen = ZORUNLU_ESADLARI[normalize(zorunlu)];
            if (cozulen === undefined)
                uyar('Zorunlu', zorunlu);
            else
                zorunluMu = cozulen;
        }
        const kod = benzersizKod(`musteri_${excelKodGovdesi(madde)}`, alanKodlari);
        alanlar.push({
            kod,
            etiket: madde.trim().slice(0, 300),
            tip: alanTipi,
            zorunlu: zorunluMu,
            gizli: false,
            sira: alanlar.length * 10 + 10,
            kaynak: 'musteri',
            bolumKodu: aktifBolum,
            ...(cevapSetiKodu ? { cevapSetiKodu } : {}),
            ...(fotografAyari ? { fotografAyari } : {}),
            ...(notAyari ? { notAyari } : {}),
        });
    }
    if (alanlar.length === 0) {
        throw new FormSablonIceAktarmaHatasi(exports.FORM_SABLON_ICE_AKTARMA_MESAJLARI.maddeYok);
    }
    // Kapsam ve varsayılan cevap seti BOŞ kalır (iş emri) — set mirası çalışma
    // zamanında kütüphane varsayılanına düşer (`cevapSetiCoz`).
    const sema = form_schema_1.formSemaTaslakSchema.parse({ bolumler, alanlar });
    return { sema, uyarilar, bolumSayisi: bolumler.length, maddeSayisi: alanlar.length };
}
/**
 * Açıklama sayfasının satırları — şablonu üreten uç bunu basar; sözlük
 * (tip · kanıt ayarı · cevap seti) kodla AYNI kaynaktan okunur, elle yazılmaz.
 */
function formSablonIceAktarmaNotlari() {
    const tipler = exports.EXCEL_ALAN_TIPLERI.map((t) => exports.EXCEL_ALAN_TIPI_ETIKETI[t]).join(' · ');
    const kanit = form_schema_1.MADDE_KANIT_AYARLARI.map((k) => exports.EXCEL_KANIT_AYARI_ETIKETI[k]).join(' · ');
    const setler = form_schema_1.CEVAP_SETI_KUTUPHANESI.map((s) => s.ad).join(' · ');
    return [
        'FORM ŞABLONU — EXCEL İÇE AKTARMA. Her satır bir maddedir; 1. satır başlıktır, değiştirilmez.',
        'Bölüm: dolu hücre yeni bölüm başlatır; boşsa önceki bölüm devam eder. İlk madde bölümsüzse "Genel" bölümü açılır. Yalnız Bölüm yazan satır başlıktır, madde üretmez.',
        'Madde: sorunun / kontrol maddesinin metni (zorunlu). Madde sütunu tamamen boşsa dosya kabul edilmez.',
        `Tip: ${tipler}. Boş bırakılırsa "Kontrol maddesi". Tanınmayan değer: madde yine açılır, tip "Kontrol maddesi" olur ve uyarı listesine düşer.`,
        `Cevap seti (yalnız Kontrol maddesinde): ${setler}. Boşsa şablonun varsayılanı kullanılır. Tanınmayan değer: boş bırakılır, uyarıya düşer.`,
        `Fotoğraf / Not: ${kanit}. Boşsa kapalı. Dosya tipinde kullanılmaz. Tanınmayan değer: boş bırakılır, uyarıya düşer.`,
        'Zorunlu: Evet / Hayır. Boşsa Evet.',
        'Yükleme yeni bir TASLAK şablon açar (v1). Kapsam (işyerleri) ve varsayılan cevap seti yüklemede boş kalır; adı, kapsamı ve maddeleri düzenleyicide tamamlayın, sonra yayınlayın.',
        'Örnek satırlar yalnız biçimi gösterir — kendi maddelerinizle değiştirin.',
    ];
}
/** Şablon dosyasındaki ÜÇ örnek satır (sayfa 1) — biçimi gösterir, yüklenirse üç maddelik bir taslak açar (zararsız: taslak silinir/düzenlenir). */
exports.FORM_SABLON_ICE_AKTARMA_ORNEK_SATIRLARI = [
    [
        'Kişisel hijyen ve KKD',
        'Bone ve galoş eksiksiz takılı mı? (örnek — silin)',
        'Kontrol maddesi',
        '',
        'İsteğe bağlı',
        'İsteğe bağlı',
        'Evet',
    ],
    ['', 'El yıkama istasyonları dolu mu? (örnek — silin)', 'Kontrol maddesi', '', '', '', 'Evet'],
    [
        'Makine ve kesici ekipman',
        'Vardiya sorumlusunun notu (örnek — silin)',
        'Uzun metin',
        '',
        '',
        '',
        'Hayır',
    ],
];
//# sourceMappingURL=form-import.js.map